export const DividerTheme = {
  baseStyle: {
    opacity: 1,
    borderColor: "border-01",
  },
};
